/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { trackedTask } from 'reactiveweb/ember-concurrency';
import { task } from 'ember-concurrency';

const PRINTING_MODES = {
  LOCAL: 'LOCAL',
  REMOTE: 'REMOTE',
};

export default class PrinterSelectorModal extends Component {
  @service electronApp;
  @service intl;
  @service printerSetup;
  @service('printing-devices') printingDevicesService;

  @tracked availablePrinters = trackedTask(this, this.getAvailablePrinters);
  @tracked printingMode = PRINTING_MODES.LOCAL;
  @tracked remotePrintingTargetId;
  @tracked selectedPrinter;
  @tracked showWarning = false;
  @tracked showWarningRemote = false;

  printingDevices = trackedTask(this, this.getPrintingDevicesTask);
  printingModes = PRINTING_MODES;

  get isOpen() {
    return this.printerSetup.showPrinterSelectorDialog;
  }

  get selectedRemotePrintingTarget() {
    return this.printingDevices.value?.find(
      (device) => device.id === this.remotePrintingTargetId
    );
  }

  @action
  selectPrinter(printer) {
    this.showWarning = false;
    this.showWarningRemote = false;
    this.selectedPrinter = printer;
  }

  @action
  selectRemotePrinterTarget(targetId) {
    this.showWarning = false;
    this.showWarningRemote = false;
    this.remotePrintingTargetId = targetId;
  }

  @action
  confirm() {
    if (this.printingMode === PRINTING_MODES.REMOTE) {
      if (!this.remotePrintingTargetId) {
        this.showWarningRemote = true;
        return;
      }
      this.printerSetup.onSelect(
        this.remotePrintingTargetId,
        this.printingMode
      );
    } else {
      if (!this.selectedPrinter) {
        this.showWarning = true;
        return;
      }
      this.printerSetup.onSelect(this.selectedPrinter?.name, this.printingMode);
    }

    this.#resetState();
  }

  @action
  close() {
    this.printerSetup.onSelect();
    this.#resetState();
  }

  @task
  *getAvailablePrinters() {
    return yield this.electronApp.getPrinters();
  }

  @task
  *getPrintingDevicesTask() {
    let printingDevices =
      yield this.printingDevicesService.fetchPrintingDevicesTask.perform();

    // Filter out this (Electron) application instance as a target device for remote printing.
    printingDevices = printingDevices.filter(
      (printingDevice) =>
        printingDevice.id !== this.electronApp.applicationInstanceId
    );

    return printingDevices;
  }

  #resetState() {
    this.printingMode = PRINTING_MODES.LOCAL;
    this.remotePrintingTargetId = undefined;
    this.selectedPrinter = undefined;
    this.showWarning = false;
    this.showWarningRemote = false;
  }
}
